module.exports = __webpack_public_path__ + "img/blob_4.d628872b.svg";